import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-question-prompt',
  templateUrl: './question-prompt.component.html',
  styleUrls: ['./question-prompt.component.css']
})
export class QuestionPromptComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
